// Hasta durumları (Patients.status). Değerler kayıtta olduğu gibi kalır;
// `excelLabel` Excel çıktısındaki Türkçe ad, ekranda etiket çevrilir.
export const PATIENT_STATUSES = [
  { value: 'planned', excelLabel: 'Planlanan', tone: 'tw-bg-amber-500/15 tw-text-amber-700 dark:tw-text-amber-300', dot: 'tw-bg-amber-500' },
  { value: 'screened', excelLabel: 'Screen Edilen', tone: 'tw-bg-blue-500/15 tw-text-blue-700 dark:tw-text-blue-300', dot: 'tw-bg-blue-500' },
  { value: 'screenFail', excelLabel: 'Screen Fail', tone: 'tw-bg-rose-500/15 tw-text-rose-700 dark:tw-text-rose-300', dot: 'tw-bg-rose-500' },
  { value: 'enrolled', excelLabel: 'Dahil Edilen', tone: 'tw-bg-violet-500/15 tw-text-violet-700 dark:tw-text-violet-300', dot: 'tw-bg-violet-500' },
  { value: 'active', excelLabel: 'Aktif', tone: 'tw-bg-emerald-500/15 tw-text-emerald-700 dark:tw-text-emerald-300', dot: 'tw-bg-emerald-500' },
  { value: 'onMedication', excelLabel: 'İlaç Alan', tone: 'tw-bg-cyan-500/15 tw-text-cyan-700 dark:tw-text-cyan-300', dot: 'tw-bg-cyan-500' },
  { value: 'completed', excelLabel: 'Tamamlanan', tone: 'tw-bg-slate-500/15 tw-text-slate-700 dark:tw-text-slate-300', dot: 'tw-bg-slate-500' },
  { value: 'withdrawn', excelLabel: 'Çekilen', tone: 'tw-bg-red-600/15 tw-text-red-700 dark:tw-text-red-300', dot: 'tw-bg-red-600' },
];

export const statusOf = (value) => PATIENT_STATUSES.find((status) => status.value === value);

/** Durumun geçerli dildeki adı; bilinmeyen değerler olduğu gibi. */
export const patientStatusLabel = (t, value) => (statusOf(value) ? t(`projectManagement.patientStatus.${value}`) : value || '-');

// Bu durumlarda kayıt (enrollment) tarihi zorunlu
export const ENROLLMENT_REQUIRED = ['enrolled', 'active', 'onMedication'];
